import { WS_DATA,APP } from './app.constants';

export const QUICK_TEXTS = `${APP}_quick_texts`;

export const WS_DATA_QUICK_TEXT = `${WS_DATA}/quickText`;
export const WS_DATA_QUICK_TEXTS = `${WS_DATA}/quickTexts`;